import InputLabel from "@/components/InputLabel"
import cn from "@/utils/cn"

type DatePickerProps = {
  selectedMonth: { year: number; month: number }
  onMonthChange: (year: number, month: number) => void
}

const DatePicker = ({ selectedMonth, onMonthChange }: DatePickerProps) => {
  const handleMonthChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    if (value) {
      const [year, month] = value.split("-").map(Number)
      onMonthChange(year, month)
    }
  }

  const formattedValue = `${selectedMonth.year}-${String(selectedMonth.month).padStart(2, "0")}`

  return (
    <div className="flex items-end gap-4">
      <div className="flex flex-col gap-1">
        <InputLabel htmlFor="month-picker" className="ml-1">
          View Month
        </InputLabel>
        <input
          id="month-picker"
          type="month"
          value={formattedValue}
          onChange={handleMonthChange}
          className={cn(
            "block w-full rounded-lg border-0 px-3 py-2 text-base leading-6 ring-1 ring-inset ring-gray-300 placeholder:text-primary/60 focus:ring-2 focus:ring-inset focus:ring-blue-600"
          )}
        />
      </div>
    </div>
  )
}

export default DatePicker
